/**
 * PREREQ global theme foundation.
 * Keep global JS intentionally small. Component-specific behaviour belongs
 * in custom elements or section-scoped assets as the theme grows.
 */
(() => {
  document.documentElement.classList.add('js');

  class PrereqQuantity extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="number"]');
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const button = event.target.closest('button[data-quantity-action]');
      if (!button || !this.input) return;

      const step = Number(this.input.step) || 1;
      const min = this.input.min === '' ? 0 : Number(this.input.min);
      const max = this.input.max === '' ? Infinity : Number(this.input.max);
      const current = Number(this.input.value) || min;
      const direction = button.dataset.quantityAction === 'increase' ? 1 : -1;
      const next = Math.min(max, Math.max(min, current + (step * direction)));

      if (next === current) return;
      this.input.value = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    };
  }

  if (!customElements.get('prereq-quantity')) {
    customElements.define('prereq-quantity', PrereqQuantity);
  }
})();
